import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-font-plus",
  "use": "icon-font-plus-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-font-plus\"><path d=\"M414.565 47.023L-0.001 977.34h97.835l136.963-305.121h379.1l138.19 305.121h94.165L436.578 47.023h-22.013zM275.154 581.304l150.419-336.26 149.193 336.26H275.154z m615.552-401.12V46.66h-89.312v133.524H667.425v87.911h133.969V401.62h89.312V268.095h133.303v-87.911H890.706z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/font-plus.svg
// module id = o1ia
// module chunks = 65